import React from 'react'
import {Modal, Title, SmallText, Subtitle} from 'shared/components/index'
import {useOrganizationById} from 'hooks/organizations'
import {useNavigate} from 'react-router-dom'
import {Button} from 'shared/components/Button'
import {ThreeCircles, Genre, DoubleChecks, Globe, User, Phone } from 'shared/assets/svgs/OrganizationsPageIcons/index'
import {Mail} from 'shared/assets/svgs/index'
import {ModalWrapper, Wrapper, Dashboard, Score, Figures} from './styles'


const OrganizationDetail = ({isOpenOrgDetailsModal, setIsOpenOrgDetailsModal, orgId}) => {
  const navigate = useNavigate()
  const organization = useOrganizationById(orgId)
  return (
    <>
      <Modal
        isOpen={isOpenOrgDetailsModal}
        toggleModal={setIsOpenOrgDetailsModal}
        width='45rem'
        height='30rem'
      >
        <section style={{width: '100%', height: '100%', margin: '4rem'}}>
          <Title margin='3rem 0 1rem 0'>{organization.name}</Title>  
          <ModalWrapper>
            <Wrapper>
              <div>
                <ThreeCircles />
                <SmallText margin='0 0.5rem'>{organization.employees_amount}</SmallText>
              </div>
              <div>
                <Genre />
                <SmallText margin='0 0.5rem'>{organization.industry_type}</SmallText>
              </div>
              <div>
                <DoubleChecks />
                <SmallText margin='0 0.5rem'>{organization.date}</SmallText>
              </div>
              <div>
                <Globe />
                <SmallText margin='0 0.5rem'>{organization.country}</SmallText>
              </div>
            </Wrapper>
            <Wrapper>
              <div>
                <Mail />
                <SmallText margin='0 0.5rem'>{organization.email}</SmallText>
              </div>
              <div>
                <User />
                <SmallText margin='0 0.5rem'>{organization.platform_responsible}</SmallText>
              </div>
              <div>
                <Phone />
                <SmallText margin='0 0.5rem'>{organization.contact}</SmallText>
              </div>
            </Wrapper>
          </ModalWrapper>

          <div style={{display: 'flex', justifyContent: 'center'}}>
            <div>
              <Subtitle>Formularios</Subtitle>
              <Dashboard>
                <Score color='#00B9B4'>
                  {organization.forms_completed}
                </Score><br />
                <SmallText>
                  Completados
                </SmallText>
              </Dashboard>
            </div>
            <div>
              <Subtitle>Detalle</Subtitle>
              <Dashboard>
                <div style={{marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between'}}>
                  <SmallText weight='600'>
                    Compromiso
                  </SmallText>
                  <Figures>
                    10%
                  </Figures>
                </div>
                <div style={{marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between'}}>
                  <SmallText weight='600'>
                    Implementación
                  </SmallText>
                  <Figures>
                    15%
                  </Figures>
                </div>
                <div style={{marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between'}}>
                  <SmallText weight='600'>
                    Medición
                  </SmallText>
                  <Figures>
                    10%
                  </Figures>
                </div>
                <div style={{marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between'}}>
                  <SmallText weight='600'>
                    En curso
                  </SmallText>
                  <Figures>
                    35%
                  </Figures>
                </div>
              </Dashboard>
            </div>
            <div>
              <Subtitle>Ranking #</Subtitle>
              <Dashboard>
                <Score color='#6C3F98'>
                  5
                </Score><br />
                <SmallText>
                  {organization.points_amount} puntos
                </SmallText>
              </Dashboard>
            </div>
          </div>

          <div style={{display: 'flex', justifyContent: 'center'}}>
            <Button background='#6C3F98' color='#FFFFFF' fontSize='base' padding='0.75rem 1.5rem' style={{margin: '0.25rem'}}
              onClick={() => navigate(`/organizaciones/edit/${orgId}`)}
            >
              Editar
            </Button>
            <Button background='#F9F8FA' color='#3D4852' fontSize='base' padding='0.75rem 1.5rem' style={{margin: '0.25rem'}}
              onClick={() => setIsOpenOrgDetailsModal(false) }
            >
              Cancelar
            </Button>
          </div>
        </section>
      </Modal>
    </>
  )
}

export {OrganizationDetail}